// passing the path into variables

const banner1 = '/assets/jm/BusesJM-WebDesign-Slide-MainBanner.jpg';
const banner2 = '/assets/jm/BusesJM-WebDesign-Slide-MainBanner.jpg';
const banner3 = '/assets/jm/BusesJM-WebDesign-Slide-MainBanner.jpg';

const banner = [banner1, banner2, banner3];

const busesJmSlides = {
  banner,
};

export default busesJmSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/busesJmSlides.js